var map = {
	"./icon_choose_1.png": "146b",
	"./icon_choose_2.png": "348c",
	"./icon_choose_3.png": "f368",
	"./icon_choose_4.png": "61d3",
	"./icon_choose_5.png": "f4ad",
	"./icon_choose_6.png": "fe51"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "60b0";